export const guideUrl =
  'https://cdn.prod.website-files.com/6044f1e731fd086115d71bf9/67338c2ca8d8ce7c57c47c35_2e7bde4a47daab5124eddf836ca86e32_Gui%CC%81a%20Payflow%20__%20A3%20%281%29_compressed.pdf';
export const fieldNameStep2 = 'includeSalaryTypes';
